<style src="@/assets/css/cockpit.css"></style>
<style>
.as-form {
  border: 1px solid #c1c1c1;
  padding: 10px;
  border-radius: 5px;
}
</style>
<template>
  <div class="container-fluid" id="as-cockpit">
    <div class="wrapper" v-if="$store.state.session.isAuth">
      <div class="container">
        <div class="title_holder">
          <h3>Админ панель</h3>
        </div>
      </div>
      <div class="container">
        <div class="row" style="padding-top: 30px">
          <div class="col-12 justify-content-center">
            <b-tabs content-class="mt-3">
              <b-tab title="Новости" active>
                <News />
              </b-tab>
              <b-tab title="Проекты">
                <Projects />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <!-- <Catalog ref="catalog" />
    <EditPage ref="editModal" />
    <Users ref="users" />
    <Orders ref="orders" /> -->
    </div>
    <div class="wrapper" v-else>
      <div class="container">
        <div class="title_holder">
          <h3>Вход админ панель</h3>
        </div>
      </div>
      <div class="container">
        <b-row align-h="center">
          <b-col cols="4">
            <b-form class="as-form" v-on:submit.prevent="sendAuth">
              <h4>Вход</h4>
              <hr/>
              <b-form-group label="Email:" label-for="email">
                <b-form-input
                  type="email"
                  name="email"
                  v-model.trim="form.email"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Пароль:" label-for="password">
                <b-form-input
                  type="password"
                  name="password"
                  v-model.trim="form.password"
                ></b-form-input>
              </b-form-group>
              <b-form-group class="text-right">
                <b-btn class="btn btn-primary btn-auth" type="submit">{{
                  $t("done")
                }}</b-btn>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
// import EditPage from "@/components/cockpit/modals/editPage.vue";
// import Catalog from "@/components/cockpit/modals/catalog.vue";
// import Users from "@/components/cockpit/modals/users.vue";
import News from "@/components/cockpit/news.vue";
import Projects from "@/components/cockpit/projects.vue";

export default {
  data() {
    return {
      locale: this.$route.params.locale,
      showToolbar: false,
      form: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    showModal(target) {
      this.sm = true;
      this.$refs[target].show = true;
      document.body.classList.add("modal-open");
      if (target === "catalog") {
        this.$store.state.waitData = true;
        this.$store.dispatch("loadAllData");
      }
    },
    sendAuth() {
      this.$auth.signIn(this.$store, this.form.email, this.form.password);
    },
  },
  components: {
    News,
    Projects
    // EditPage,
    // Catalog,
    // Users,
    // Orders
  },
};
</script>
